<template>
  <div class="details" v-if="options && options.participantIdFormatConfigured">
    <div class="card br-2">
      <div class="p-10">
        <div>
          <h6 class="fw-bold">PARTICIPANT ID</h6>
          <div class="expand-collapse-container">
            <a href="" class="col-1 p-0 make-link" @click.prevent="expandAll()">Expand all</a>
            <span class="link_style"></span>
            <a href="" class="col-1 p-0 make-link" @click.prevent="collapseAll()">Collapse all</a>
          </div>
          <div class="pt-10 row">
            <div class="col-lg-3 col-md-7 p-0">Participant ID is required:</div>
            <div class="col-lg-3 col-md-5 seperate less-width fw-bold">
              {{ options.isParticipantIdRequired ? "Enabled" : "Disabled" }}
            </div>
          </div>
          <div class="pt-10 row">
            <div class="col-lg-3 col-md-7 p-0">Participant ID is editable:</div>
            <div class="col-lg-3 col-md-5 seperate less-width fw-bold">
              {{ options.isParticipantIdEditable ? "Enabled" : "Disabled" }}
            </div>
          </div>
          <div class="pt-8 row">
            <div class="col-lg-3 col-md-7 p-0">
              <i class="fa fa-plus-circle pr-6" v-if="!expandParticipantInfo && options.participantIdFormatConfigured.isFormattingChecked" @click.prevent="expandParticipantInfo = true"></i>
              <i class="fa fa-minus-circle pr-6" v-if="expandParticipantInfo && options.participantIdFormatConfigured.isFormattingChecked" @click.prevent="expandParticipantInfo = false"></i>
              Configure formatting
            </div>
            <div
              class="col-lg-3 col-md-5 seperate less-width-2 fw-bold"
              :class="{
                expandable: options.participantIdFormatConfigured.isFormattingChecked,
                'increase-margin': !options.participantIdFormatConfigured.isFormattingChecked
              }"
            >
              {{ options.participantIdFormatConfigured.isFormattingChecked ? "Enabled" : "Disabled" }}
            </div>
          </div>
          <div v-if="expandParticipantInfo">
            <div class="card inner-card br-2">
              <div class="pt-10">
                <b-row class="pb-10">
                  <b-col class="pl-0">
                    <div class="header">Restrict number of characters</div>
                    <div class="content">
                      {{ options.participantIdFormatConfigured.size }}
                    </div>
                  </b-col>
                  <b-col class="pl-0">
                    <div class="header">Format</div>
                    <div class="content" v-html="processFormatting"></div>
                  </b-col>
                </b-row>
                <b-row class="pb-10">
                  <b-col class="pl-0">
                    <div class="header">Additional formatting</div>
                    <div class="content" v-if="options.participantIdFormatConfigured.isDisallowSpecialCharacters">
                      Disallow special characters
                    </div>
                    <div class="content" v-if="options.participantIdFormatConfigured.isDisallowNumbers">
                      Disallow numbers
                    </div>
                    <div class="content" v-if="options.participantIdFormatConfigured.isDisallowLetters">
                      Disallow letters
                    </div>
                    <div class="content" v-if="!(options.participantIdFormatConfigured.isDisallowLetters || options.participantIdFormatConfigured.isDisallowSpecialCharacters || options.participantIdFormatConfigured.isDisallowNumbers)">
                      N/A
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
        <div class="pt-10 row">
          <div class="col-lg-3 col-md-7 p-0">
            Allow duplicate Participant IDs:
          </div>
          <div class="col-lg-3 col-md-5 seperate less-width-3 fw-bold">
            {{ allowDuplicatePid ? "Enabled" : "Disabled" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* 
IMPORTANT
Please make sure that this file and participant-configuration.vue which is inside the study-details folder are in sync so that the PDF is updated with the most recent code.
 */
export default {
  name: "participant-configuration",
  data() {
    return {
      expandParticipantInfo: false
    };
  },
  components: {},
  props: {
    options: {
      type: Object
    },
    allowDuplicatePid: {
      type: Boolean
    }
  },
  computed: {
    processFormatting() {
      let html = "N/A";
      if (this.options.participantIdFormatConfigured.format) {
        html = "";
        const formatArray = JSON.parse(this.options.participantIdFormatConfigured.format);
        formatArray.map(chOld => {
          let ch = chOld;
          ch = ch == null ? "_" : ch;
          html += '<span style="margin-right:4px;">' + ch + "</span>";
        });
      }
      return html;
    }
  },
  methods: {
    expandAll() {
      this.expandParticipantInfo = true;
    },
    collapseAll() {
      this.expandParticipantInfo = false;
    }
  },
  mounted() {
    this.expandAll();
  }
};
</script>

<style lang="scss" scoped>
.link_style {
  border-right: 1px solid #959fa4;
  margin: 0px 5px 0px 2px !important;
}
.inner-card {
  border: none;
  margin: 5px 20px;
  border-radius: 3px !important;
  background-color: #d3dfe4;
}
.header {
  font-size: 12px;
  color: #666669;
}
.content {
  font-size: 12px;
  font-weight: bold;
  color: #666669;
}
.make-link {
  color: #007bff !important;
}
.seperate {
  width: 6.9%;
  /* margin-left: 18%; */
  text-align: left;
  &.expandable {
    margin-left: 18.6%;
  }
  &.less-width {
    /* margin-left: 85px; */
    font-family: Roboto-Regular;
    font-size: 12px;
    color: #666669;
  }
  &.less-width-2 {
    /* margin-left: 90px; */
    font-family: Roboto-Regular;
    font-size: 12px;
    color: #666669;
  }
  &.less-width-3 {
    /* margin-left: 46px; */
    font-family: Roboto-Regular;
    font-size: 12px;
    color: #666669;
  }
}
</style>
